<template>
    <div class="horizontal-scroll">
        <div v-if="is_api_calling" class="d-flex justify-content-center align-items-center">
            <!-- <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" /> -->
            <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
        </div>
        <div v-else>
            <div class="p-5 position-content-main">
                <div class="breadcrumbnewtheme pb-3">
                    <div class="pre gap-0p5 fw-500">
                        Settings
                    </div>
                    <span style="color:#b2bec3">/</span>
                    <div class="pre gap-0p5 fw-500">
                        Templates
                    </div>
                    <span style="color:#b2bec3">/</span>
                    <span class="curr gap-0p5 fw-500">
                        General
                    </span>
                </div>
                <div class="mt-4 p-4" style="background-color: #fff;border-radius: 10px; min-height: max-content;">
                    <div class="tab-list d-flex align-items-center justify-content-between">
                        <!-- <ul class="d-flex align-items-center pl-0 mb-0">
                            <li class="d-flex align-items-center px-3" > -->
                                <span class="list-text fs-20 fw-600 text-black">General Settings</span>
                            <!-- </li> -->
                        <!-- </ul> -->
                    </div>
                    <div class="content mt-3" style="border: 0.3px solid #0d84f2;border-radius: 10px;">
                        <div class="row px-4">
                            <div class="col-lg-8 col-md-8 col-sm-12">
                                <div class="form-group contactGroup">
                                    <div class="w-100" style="position: relative;">
                                        <label class="inputLabel fs-14 fw-500 text-black">SLA Working Days <span class="text-danger">*</span></label>
                                        <input class="inputFieldNew inputFieldNew-padding" style="background: #f1f1f1 !important;" v-validate="'required'" data-vv-as="SLA Working Days" maxlength="3" name="sla_working_days" v-model="sla_working_days" type="number" autocomplete="off" placeholder="SLA Working Days" :disabled="!edit_general"/>
                                        <span class="inputBorder"></span>
                                    </div>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('sla_working_days')">{{errors.first('sla_working_days')}}</span>
                            </div>
                            <div class="col-lg-8 col-md-8 col-sm-12">
                                <div class="form-group contactGroup">
                                    <div class="w-100" style="position: relative;">
                                        <label class="inputLabel fs-14 fw-500 text-black">Archive After Days <span class="text-danger">*</span></label>
                                        <input class="inputFieldNew inputFieldNew-padding"  style="background: #f1f1f1 !important;" v-validate="'required'" data-vv-as="Archive After Days" maxlength="3" name="archive_after_days" v-model="archive_after_days" type="number" autocomplete="off" placeholder="Archive After Days" :disabled="!edit_general"/>
                                        <span class="inputBorder"></span>
                                    </div>
                                </div>
                                <span class="invalid-feedback-form text-danger" v-show="errors.has('archive_after_days')">{{errors.first('archive_after_days')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-between my-4">
                    <div></div>
                    <div v-if="!edit_general">
                        <button type="button" class="btn btn-edit" @click="goToEdit">
                            <i class="icon mr-1 ri-pencil-line fs-21 text-white" ></i>
                            <!-- <i class=" fs-22 text-white item"></i> -->
                            Edit
                        </button>
                    </div>
                    <div v-else>
                        <button type="button" class="btn btn-danger-new" @click="goToListView" >Cancel</button>
                        <button type="button" class="btn btn-green ml-4" :disabled="is_api_calling || save_loader" :class="{'text-align-left' : save_loader}" @click="createSuccess" style="width: 100px">
                            {{ save_loader ? 'Saving' : 'Save' }}
                            <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import dynamic_template from '../../mixins/dynamic_template'
import { SweetModal } from 'sweet-modal-vue';
export default {
    mixins: [dynamic_template],
    components: {
        SweetModal,
        HalfCircleSpinner
    },
    data() {
        return {
            success_msg:'',
            warning_msg:'',
            sla_working_days: 0,
            archive_after_days: 0,
            is_api_calling: false,
            general_settings_id: '',
            save_loader: false,
            edit_general: false
        }
    },
    methods: {
        async goToListView(){
            this.edit_general = false
            try {
                let params = {
                    limit: 10,
                    skip: 0,
                    sort_key: "",
                    sort_value: 1
                };
                let response = await this.listDynamicGeneralSettings(params);
                if(response.response.length > 0){
                    this.sla_working_days = response.response[0].sla_work_days;
                    this.archive_after_days = response.response[0].archive_after_days
                    this.general_settings_id = response.response[0]._id;
                }
            }
            catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        },
        goToEdit(){
            this.edit_general = true
        },
        async createSuccess() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.saveData();
                } else {

                }
            });
        },
        async saveData() {
            // this.is_api_calling = true;
            this.save_loader = true
            try {
                let response = await this.updateDynamicGeneralSettings(this.create_data);
                this.success_msg = response.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.edit_general = false
                    this.save_loader = false
                    this.getListData();
                }, 3000);
            }
            catch (error) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                // this.is_api_calling = false;
                this.save_loader = false
            }
        },
        async getListData() {
            this.is_api_calling = true;
            try {
                let params = {
                    limit: 10,
                    skip: 0,
                    sort_key: "",
                    sort_value: 1
                };
                let response = await this.listDynamicGeneralSettings(params);
                if(response.response.length > 0){
                    this.sla_working_days = response.response[0].sla_work_days;
                    this.archive_after_days = response.response[0].archive_after_days
                    this.general_settings_id = response.response[0]._id;
                }
                this.is_api_calling = false;
            }
            catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        }
    },
    mounted() {
        this.getListData();
    },
    computed: {
        create_data() {
            return {
                _id: this.general_settings_id,
                general: {
                    archive_after_days: this.archive_after_days,
                    sla_work_days: this.sla_working_days
                }
            }
        }
    },
    created(){
        const dict = {
            custom: {
                sla_working_days:{
                    required:() => "SLA working days is Required",
                },
                archive_after_days:{
                    required:() => "Archive after days is Required",
                },
            }
        }
        this.$validator.localize("en", dict);
    }
}
</script>
<style scoped>
.text-new-blue{
    color: #00448b;

}
.horizontal-scroll{
    overflow-x: hidden;
}
.text-align-left{
    text-align: left !important;
}
.gap-0p5{
    gap: 0.5rem;
}
.breadcrumbnewtheme{
    display: flex;
    align-items: center;
    gap: 1rem;
    border-bottom: 2px solid #636e71;
}
.breadcrumbnewtheme div{
    color: #00448b;
}
.fs-2rem{
    font-size: 2rem;
}
.position-content-main{
    height: auto;
    border-radius: 14px;
    background-color: #f0ddb7;
}
.header-color{
    color: #4e4e4e !important;
}
.btn-edit{
    background: #00448b !important;
    color: #fff !important;
    border-radius: 5px !important;
    border: 1px solid #00448b !important;
    text-transform: capitalize !important;
}
</style>